var Core = require('./Core');
module.exports = Core;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/uppy/lib/core/index.js
// module id = 75
// module chunks = 0